(function() {
    'use strict';

    angular.module('caffeprint', [
            'caffeprint.constants',
            'caffeprint.services',

            'ngResource',
            'ngSanitize',
            'ui.router',
            'ui.bootstrap',
            'ui.select',
            'ui.sortable',
            'ui.bootstrap.datetimepicker',
            'ui.bootstrap.contextMenu',
            'frapontillo.bootstrap-duallistbox',
            'summernote',
            'toaster',
            'ngIntlTelInput',
            'threeStateCheckbox',
            'LocalStorageModule',
            'localytics.directives',
            'ngJsTree',
            'vs-repeat',
            'chart.js',

            'user',
            'product',
            'appliances',
            'settings',
            'format',
            'settings',
            'holiday',
            'file',
            'news',
            'machine',
            'page',
            'process',
            'order',
            'competence',
            'montage',
            'plate',
            'stats',
            'daterangepicker',
            'sites',
            'notes',
            'tags',
            'allegro',
            'ksef'
        ])
        .config(csrfToken)
        .config(html5ModeURLs)
        .config(hashBangURLs)
        .config(stripTrailingSlashes)
        .config(uiRouting)
        .config(csrfToken)
        .config(langHeaderInterceptor)
        .config(uniqueRequestsInterceptor)
        .run(bodyClass);

    csrfToken.$inject = ['$httpProvider'];

    function csrfToken($httpProvider) {
        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
    }

    html5ModeURLs.$inject = ['$locationProvider'];

    function html5ModeURLs($locationProvider) {
        $locationProvider.html5Mode(true);
    }

    hashBangURLs.$inject = ['$locationProvider'];

    function hashBangURLs($locationProvider) {
        $locationProvider.hashPrefix('!');
    }

    stripTrailingSlashes.$inject = ['$resourceProvider'];

    function stripTrailingSlashes($resourceProvider) {
        $resourceProvider.defaults.stripTrailingSlashes = false;
    }

    langHeaderInterceptor.$inject = ['$httpProvider'];

    function langHeaderInterceptor($httpProvider) {
        $httpProvider.interceptors.push('langHeaderInterceptor');
    }

    uiRouting.$inject = ['$urlRouterProvider', '$stateProvider', 'userPermissionsConst'];

    function uiRouting($urlRouterProvider, $stateProvider, userPermissionsConst) {
        $urlRouterProvider.otherwise('/');

        $stateProvider
            .state('layout', {
                abstract: true,
                views: {
                    'content@': {
                        templateUrl: 'app/caffeprint/views/layout/layout.html',
                        controller: 'LayoutController',
                        controllerAs: 'ctrl'
                    },
                    'navigation@layout': {
                        templateUrl: 'app/caffeprint/views/navigation/navigation.html',
                        controller: 'NavigationController',
                        controllerAs: 'ctrl',
                    },
                    'topnavbar@layout': {
                        templateUrl: 'app/caffeprint/views/topnavbar/topnavbar.html',
                        controller: 'TopnavbarController',
                        controllerAs: 'ctrl',
                    },
                    'footer@layout': {
                        templateUrl: 'app/caffeprint/views/footer/footer.html',
                        controller: 'FooterController',
                        controllerAs: 'ctrl',
                    }
                },
                data: {
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.home', {
                url: '/',
                views: {
                    'main@layout': {
                        templateUrl: 'app/caffeprint/views/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'ctrl',
                    }
                },
                data: {
                    title: 'Strona domowa'
                }
            });
    }

    bodyClass.$inject = ['$rootScope', '$document', '$timeout'];

    function bodyClass($rootScope, $document, $timeout) {
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            $rootScope.bodyClass = toState.data.bodyClass || undefined;
            $timeout(function () {
                $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
            });
        });
    }

    uniqueRequestsInterceptor.$inject = ['$httpProvider'];

    function uniqueRequestsInterceptor($httpProvider) {
        $httpProvider.interceptors.push('uniqueRequestsInterceptor');
    }
})();
